export const DERIVATIVES_FUND_PURCHASE_ERROR =
  "Only Professional Investors or clients with signed Knowledge of Derivatives can buy derivative funds.";

export const canClientBuyDerivativesFund = (client = {}) =>
  Boolean(client.professionalInvestor || client.knowledgeOfDerivatives);

export const isDerivativesFund = (fundOrProduct = {}) =>
  fundOrProduct?.derivativesFund === true;

export const getDerivativesFundPurchaseError = (client, products = []) => {
  if (canClientBuyDerivativesFund(client)) return null;
  const list = Array.isArray(products) ? products : [products];
  const blocked = list.some(isDerivativesFund);
  return blocked ? DERIVATIVES_FUND_PURCHASE_ERROR : null;
};

export const filterFundsByDerivativesEligibility = (funds = [], client = {}) => {
  if (canClientBuyDerivativesFund(client)) return funds;
  return funds.filter((fund) => !isDerivativesFund(fund));
};

export const resolveDerivativesEligibilityClient = (
  orderOrTransaction = {}
) => {
  const order = orderOrTransaction.orderId ?? orderOrTransaction;
  const client = order?.client ?? orderOrTransaction.client ?? {};
  return {
    professionalInvestor: Boolean(
      client.professionalInvestor || order?.professionalInvestor
    ),
    knowledgeOfDerivatives: Boolean(client.knowledgeOfDerivatives),
  };
};
